export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_08.05b1c6f3.jpg";